<template>
    <div>
    
        <h1> Update Tour Manager Details </h1>
    
        <div class="box">
    
          <Errors/>
    
          <form class="form" v-on:submit.prevent="updateTourManager">
    
            <TourManagerFields />
    
            <div class="form-wrap form-submit">
              <div v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled>Creating...</button>
              </div>
              <div v-else>
                <button type="submit" class="button" v-if="userRole == 1">Update Template</button>
              </div>
            </div>
    
          </form>
    
        </div>
        
        <InvoicesWithDetails :invoiceFor="tour_manage" 
                              invoiceForTag="tour_manager"
                              :invoices="tour_manager_invoices"
                              @handle-new-invoice="updateInvoiceList"/>
    </div>
    
    </template>
    
    <script>

    import TourManagerFields from '@/components/TourManagerFields.vue'
    import InvoicesWithDetails from '@/components/InvoicesWithDetails.vue'
    import Errors from '@/components/Errors.vue'

    import {mapGetters} from 'vuex'

    export default {

      name: 'EmailTemplteEdit',

      computed: mapGetters(['getLoadStatus']),

      data () {
        return {
          tour_manage: {},
          errors: null,
          tour_manager_invoices: [],
          userRole: localStorage.getItem("user_role")
        }
      },
      components: {
        TourManagerFields,
        Errors,
        InvoicesWithDetails
      },
      created () {
        this.getTourManager()
      },
      watch: {
        '$route': 'getEmailTemplate'
      },
      methods: {
        getTourManager () {
          this.$store.dispatch('setLoadStatus')
          fetch(this.$api + 'tour-managers/' + this.$route.params.id + '/manager', {
              headers: {
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
              }
            })
          .then(res => res.json())
          .then(response => {
            this.$store.dispatch('setLoadStatus')
            this.tour_manage = response.data
            this.tour_manager_invoices = response.data.payment_invoices
          })
        },
        updateTourManager () {
          this.$store.dispatch('setLoadStatus')

          fetch(this.$api + 'tour-managers/' + this.$route.params.id + '/update', {
            method: 'POST',
            body: JSON.stringify(this.tour_manage),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          })
          .then(res => res.json())
          .then(response => {
            if(response.status) {
              this.$router.push({ name: 'tour-manager'})
              this.$notify({
                  type: 'success',
                  title: response.message
              });
            } else if (response.errors) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            }
            this.$store.dispatch('setLoadStatus')
          });
        },
        updateInvoiceList(invoice_object) {
          this.tour_manager_invoices = invoice_object
        }
      }
    }
    </script>
    